<template>
    <div class="discount-selection">
        <p class="discount-selection-title">暂无优惠</p>
    </div>
</template>

<script>
export default {
    
}
</script>

<style lang="scss" scoped >
.discount-selection{
   
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

}

.discount-selection-title{
    margin-top: 200px;
    font-size: 32px;
    color: var(--text-color);
}
</style>